module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.$route.name == 'NewsList') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" News\n          "), (_vm.$_allowCreating) ? _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/content/news/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowSearchAdministration) ? _c('button', {
    staticClass: "add-to-index-all btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_addToIndexAll('news')
      }
    }
  }, [_vm._v("\n            Add all to search index\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.allowRegenerateThumbs) ? _c('button', {
    staticClass: "regenerate-thumbs btn btn-primary btn-sm pull-right",
    on: {
      "click": function($event) {
        return _vm.$_regenerateThumbs('news', 'News')
      }
    }
  }, [_vm._v("\n            Regenerate thumbnails\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by News title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('EmptyBtns', {
    attrs: {
      "empty-search": _vm.emptySearch
    },
    on: {
      "showEmpty": function () { return _vm.emptySearch = true; },
      "showAll": function () { return _vm.emptySearch = false; }
    }
  }), _vm._v(" "), _c('BulkBtns', {
    class: {
      hidden: !_vm.choosenEntities.length
    },
    attrs: {
      "entity-type": "news",
      "unpublish-empty-endpoint": "news/unpublish-empty",
      "choosen-entities": _vm.choosenEntities,
      "show-index-btn": true
    },
    on: {
      "changePublishedBtns": _vm.$_changePublishedBtns,
      "clearChoosenEntities": function () { return _vm.choosenEntities = []; }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "table-list__cell--narrow"
  }, [_c('input', {
    ref: "allEntities",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.$_selectAllEntities
    }
  })]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.choosenEntities),
        expression: "choosenEntities"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.choosenEntities) ? _vm._i(_vm.choosenEntities, item.id) > -1 : (_vm.choosenEntities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.choosenEntities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.choosenEntities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.choosenEntities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.choosenEntities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.allowSearchAdministration) ? _c('button', {
      staticClass: "add-to-index-single btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_addToIndexSingle('news', item.id)
        }
      }
    }, [_vm._v("\n                      Add to index "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'NewsEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.allowPublishing) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_changePublished(item.published, 'news', item.id)
        }
      }
    }, [(item.published) ? [_vm._v("Unpublish")] : [_vm._v("Publish")], _vm._v(" "), _c('span', {
      ref: ("publishBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })], 2) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_regThumb(item, 'news', 'News')
        }
      }
    }, [_vm._v("\n                      Reg. thumb\n                      "), _c('span', {
      ref: ("_regThumbBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), (_vm.$_allowDeleting(item)) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'news/', 'News')
        }
      }
    }, [_vm._v("\n                      Delete\n                      "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("\n            There are no entities for your request\n          ")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01ab6ad8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/content/news/Index.vue
// module id = 805
// module chunks = 0